import {Alert} from 'antd';
import {useMemo} from 'react';

import {useCatalogInfo} from '../../../../provider/catalogs/catalogs-hook';
import {useHelpLink} from '../../../../provider/help-links/help-links-hook';
import {useLocale} from '../../../../provider/locale/locale-hook';
import {useFormat} from '../../../../util/format-hook/format-hook';
import {PROVIDER_TO_ITS_ID_MAP, ProvidersEnum} from '../../../../util/type';

import {
    isConfigDateValid,
    isOnlinePresenceTemporaryProblemsConfig,
    onlinePresenceWarningHelpLinkKey,
} from './online-presence-warning-helper';
import * as styles from './online-presence-ananytics-temporary-problems.scss';

type PropsType = {
    provider?: ProvidersEnum;
};

export function OnlinePresenceAnalyticsTemporaryProblems(props: PropsType): JSX.Element | null {
    const {provider} = props;
    const {getLocalizedString} = useLocale();
    const {getCatalogName} = useCatalogInfo();
    const {getFormattedDateTime} = useFormat();

    const helpLink = useHelpLink(onlinePresenceWarningHelpLinkKey, true);

    const config = useMemo(() => {
        if (!helpLink || !isOnlinePresenceTemporaryProblemsConfig(helpLink.config)) {
            return null;
        }

        return helpLink.config;
    }, [helpLink]);

    const catalogNames = useMemo(() => {
        if (!config) {
            return [];
        }

        if (provider) {
            if (!config.catalogs.includes(provider)) {
                return [];
            }

            return [getCatalogName(PROVIDER_TO_ITS_ID_MAP[provider])];
        }

        return config.catalogs.map((catalog) => getCatalogName(PROVIDER_TO_ITS_ID_MAP[catalog]));
    }, [config, getCatalogName, provider]);

    // Формирование сообщения
    const message = useMemo(() => {
        if (!config) {
            return '';
        }

        return getLocalizedString('ONLINE_PRESENCE_ANALYTICS__TEMPORARY_PROBLEMS', {
            catalogNames: catalogNames.join(', '),
            untilDate: getFormattedDateTime(new Date(config.untilDate), {
                day: 'numeric',
                month: 'long',
            }),
        });
    }, [catalogNames, config, getLocalizedString, getFormattedDateTime]);

    if (catalogNames.length === 0 || !config || !isConfigDateValid(config.untilDate)) {
        return null;
    }

    return (
        <Alert className={styles.OnlinePresenceAnalyticsTemporaryProblems} message={message} showIcon type="warning" />
    );
}
